"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSize = void 0;
const tslib_1 = require("tslib");
const resize_observer_1 = tslib_1.__importDefault(require("@react-hook/resize-observer"));
const react_1 = require("react");
const useSize = (target) => {
    const [size, setSize] = (0, react_1.useState)({});
    (0, react_1.useLayoutEffect)(() => {
        if (!target.current) {
            return;
        }
        setSize(target.current.getBoundingClientRect());
    }, [target]);
    (0, resize_observer_1.default)(target, (entry) => setSize(entry.contentRect));
    return size;
};
exports.useSize = useSize;
//# sourceMappingURL=index.js.map